import { Typography } from '@scale/scaleui';

export const NotAuthorized: React.FC = () => {
  return (
    <div className="p-8 h-full flex flex-col items-start gap-4">
      <Typography.H4>You are not authorized to view this page.</Typography.H4>
    </div>
  );
};
